import React, { useEffect, useMemo, useState } from "react"
import {
  Table,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Input,
  Modal,
  Form,
} from "reactstrap"
import { Link } from "react-router-dom"
import { useTable, useGlobalFilter, usePagination } from "react-table"
import { useNavigate } from "react-router-dom"

// css
import "../../../assets/css/Settings/Setting.css"
import editEventImg from "../../../assets/images/Digital Marketing/editEventImg.jpg"

// commom
import Pagination from "components/Common/Pagination"
import { fetchNodeData, FetchNodePostData } from "utils/common-fetchData"
import secureLocalStorage from "react-secure-storage"
import { TenderSourceColumns } from "utils/columns/Marketing/TenderCols"
import axios from "axios"
import configure from "configure"
import Swal from "sweetalert2"

function TableContainer({
  columns,
  data,
  onAddSubmit,
  addModal,
  setAddModal,
  addName,
  setAddName,
  addUrl,
  setAddUrl,
}) {
  const [fixedContent, setFixedContent] = useState(false)
  const navigate = useNavigate()

  document.addEventListener("scroll", () => {
    if (window.scrollY > 165) {
      setFixedContent(true)
    } else {
      setFixedContent(false)
    }
  })

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    state,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    gotoPage,
    setPageSize,
    pageOptions,
    setGlobalFilter,
    prepareRow,
  } = useTable({ columns, data }, useGlobalFilter, usePagination)

  const { pageIndex, pageSize, globalFilter } = state

  return (
    <div>
      {/* Floating Buttons */}
      <div
        className={`flex-column fixed-buttons ${
          fixedContent ? "d-flex" : "d-none"
        }`}
      >
        <button
          onClick={() => setAddModal(true)}
          className="btn btn-purple border-radius fix-btn"
        >
          <i className="fas fa-plus me-2 icon-size"></i> <span>Site</span>
        </button>
        <button
          onClick={() => navigate(-1)}
          className="btn btn-red border-radius fix-btn"
        >
          <i className="dripicons-cross me-2 icon-center"></i>{" "}
          <span>Cancel</span>
        </button>
      </div>

      {/* Toolbar */}
      <Row className="mb-2">
        <Col>
          <select
            className="border-radius form-select"
            style={{ width: "100px" }}
            value={pageSize}
            onChange={e => setPageSize(e.target.value)}
          >
            {[10, 20, 30, 40, 50].map(size => (
              <option key={size} value={size}>
                Show {size}
              </option>
            ))}
          </select>
        </Col>
        <Col md={8} className="d-flex justify-content-end">
          <div className="me-4">
            <div className="search-box d-inline-block">
              <div className="position-relative">
                <input
                  onChange={e => setGlobalFilter(e.target.value)}
                  type="text"
                  className="border-radius form-control rounded h-100"
                  placeholder=" Search..."
                  value={globalFilter || ""}
                />
                <i className="bx bx-search-alt search-icon"></i>
              </div>
            </div>
          </div>
          <div>
            <button
              onClick={() => setAddModal(true)}
              className="border-radius btn btn-purple"
            >
              <i className="fas fa-plus me-2 icon-size"></i> Add Site
            </button>
            <button
              onClick={() => navigate(-1)}
              className="border-radius btn ms-md-2 btn-red"
            >
              <i className="dripicons-cross me-2 icon-center"></i> CANCEL
            </button>
          </div>
        </Col>
      </Row>

      {/* Data Table */}
      <Table className="table table-bordered mt-4" {...getTableProps()}>
        <thead className={fixedContent ? "fixed-setting-header" : ""}>
          {headerGroups.map((headerGroup, i) => (
            <tr key={i} {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column, idx) => (
                <th
                  key={idx}
                  className={`col-md-${idx === 1 || idx === 2 ? "4" : "2"}`}
                  {...column.getHeaderProps()}
                >
                  {column.render("Header")}
                  {column.isInfoIcon && (
                    <i
                      title="info"
                      className="bx bx-info-circle ms-1 info-icon"
                    ></i>
                  )}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.map((row, i) => {
            prepareRow(row)
            return (
              <tr {...row.getRowProps()} key={i}>
                {row.cells.map((cell, idx) => (
                  <td
                    key={idx}
                    className={`col-md-${idx === 1 || idx === 2 ? "4" : "2"}`}
                    {...cell.getCellProps()}
                  >
                    {cell.render("Cell")}
                  </td>
                ))}
              </tr>
            )
          })}
        </tbody>
      </Table>

      {/* Pagination */}
      <Row className="justify-content-md-end justify-content-center align-items-center">
        <Pagination
          gotoPage={gotoPage}
          previousPage={previousPage}
          canPreviousPage={canPreviousPage}
          nextPage={nextPage}
          canNextPage={canNextPage}
          pageIndex={pageIndex}
          pageOptions={pageOptions}
        />
      </Row>

      {/* Add Site Modal */}
      <Modal isOpen={addModal} size="lg" centered>
        <div className="modal-header py-3 px-4 border-bottom-0">
          <h5 className="modal-title mt-0">Add Site</h5>
          <button
            type="button"
            onClick={() => setAddModal(false)}
            className="btn-modal-close"
          >
            <span className="btn-modal-span">&times;</span>
          </button>
        </div>
        <div className="modal-body p-4">
          <Form onSubmit={onAddSubmit}>
            <Row>
              <div className="col-md-5 d-flex justify-content-end align-items-center ps-3">
                <div className="text-center">
                  <img src={editEventImg} alt="Site" style={{ width: "90%" }} />
                </div>
              </div>
              <div className="col-7 d-flex flex-column justify-content-center align-items-start">
                <div className="mb-3 col-12">
                  <label className="form-label">Site Name</label>
                  <Input
                    type="text"
                    value={addName}
                    onChange={e => setAddName(e.target.value)}
                    placeholder="Enter Site Name"
                    required
                  />
                </div>
                <div className="mb-3 col-12">
                  <label className="form-label">Site URL</label>
                  <Input
                    type="text"
                    value={addUrl}
                    onChange={e => setAddUrl(e.target.value)}
                    placeholder="Enter URL"
                    required
                  />
                </div>
              </div>
            </Row>
            <Row>
              <Col className="col-12 text-end">
                <button type="submit" className="btn btn-purple border-radius">
                  <i className="fas fa-save me-1"></i> Submit
                </button>
              </Col>
            </Row>
          </Form>
        </div>
      </Modal>
    </div>
  )
}

const TenderSite = () => {
  const [editModel, setEditModel] = useState(false)
  const [isLoading, setLoading] = useState(false)
  const [data, setData] = useState([])
  const [addModal, setAddModal] = useState(false)
  const [addName, setAddName] = useState("")
  const [addUrl, setAddUrl] = useState("")
  const [id, setId] = useState("")
  const [name, setName] = useState("")
  const [url, setUrl] = useState("")

  const toggleLoading = loading => setLoading(loading)

  const fetchData = async () => {
    try {
      const response = await fetchNodeData(
        toggleLoading,
        "tenderSource",
        secureLocalStorage?.getItem("auth_token")
      )
      if (response?.data) {
        setData(response.data)
      }
    } catch (error) {
      console.error("Fetch Error", error)
    }
  }

  useEffect(() => {
    fetchData()
  }, [])

  const toggleEdit = (editId, editName, editUrl) => {
    setId(editId)
    setName(editName)
    setUrl(editUrl)
    setEditModel(true)
  }

  const handleDelete = async deleteId => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "Do you really want to delete this site?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, Delete it!",
        cancelButtonText: "Cancel",
      })

      if (result.isConfirmed) {
        const response = await axios.delete(
          `${configure.nodeApi}/tenderSource/${deleteId}`
        )

        if (response?.data?.data) {
          Swal.fire({
            icon: "success",
            text: "Deleted Successfully",
          })
          setData(response.data.data) // Reset with updated data
        } else {
          Swal.fire({
            icon: "error",
            text: response.data.message || "Something went wrong",
          })
        }
      }
    } catch (e) {
      Swal.fire({
        icon: "error",
        text: e.message,
      })
    }
  }

  const handleAddSite = async (e) => {
  e.preventDefault()
  try {
    const response = await FetchNodePostData(
      toggleLoading,
      `tenderSource`,
      secureLocalStorage?.getItem("auth_token"),
      { name: addName, url: addUrl }
    )
    if (response.status === 200) {
      setAddModal(false)
      setAddName("")
      setAddUrl("")
      fetchData()
      Swal.fire({ icon: "success", text: "Site Added Successfully" })
    }
  } catch (err) {
    console.error("Error adding site:", err)
    Swal.fire({ icon: "error", text: "Failed to Add Site" })
  }
}
  const closeModal = () => {
    setEditModel(false)
    setId("")
    setName("")
    setUrl("")
  }

  return (
    <>
      <Row className="ms-0 pe-0">
        <Col lg={12} className="p-0">
          <Card>
            <CardBody>
              <TableContainer
                columns={TenderSourceColumns(toggleEdit, handleDelete)}
                data={data}
                addModal={addModal}
                setAddModal={setAddModal}
                addName={addName}
                setAddName={setAddName}
                addUrl={addUrl}
                setAddUrl={setAddUrl}
                onAddSubmit={handleAddSite}
              />
            </CardBody>
          </Card>
        </Col>
      </Row>

      {/* Edit Modal */}
      <Modal isOpen={editModel} size="lg" centered>
        <div className="modal-header py-3 px-4 border-bottom-0">
          <h5 className="modal-title mt-0">Edit Site</h5>
          <button
            type="button"
            onClick={closeModal}
            className="btn-modal-close"
          >
            <span className="btn-modal-span">&times;</span>
          </button>
        </div>
        <div className="modal-body p-4">
          <Form
            onSubmit={e => {
              e.preventDefault()
              // Call your update function here
            }}
          >
            <Row>
              <div className="col-md-5 d-flex justify-content-end align-items-center ps-3">
                <div className="text-center">
                  <img src={editEventImg} alt="Site" style={{ width: "90%" }} />
                </div>
              </div>
              <div className="col-7 d-flex flex-column justify-content-center align-items-start">
                <div className="mb-3 col-12">
                  <label className="form-label">Site Name</label>
                  <Input
                    type="text"
                    value={name}
                    onChange={e => setName(e.target.value)}
                    placeholder="Enter Site Name"
                    className="form-control"
                  />
                </div>

                <div className="mb-3 col-12">
                  <label className="form-label">Site URL</label>
                  <Input
                    type="text"
                    value={url}
                    onChange={e => setUrl(e.target.value)}
                    placeholder="Enter URL"
                    className="form-control"
                  />
                </div>
              </div>
            </Row>
            <Row>
              <Col className="col-12 text-end">
                <button type="submit" className="btn btn-purple border-radius">
                  <i className="fas fa-save me-1"></i> Submit
                </button>
              </Col>
            </Row>
          </Form>
        </div>
      </Modal>
    </>
  )
}

export default TenderSite
